import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { getTerminologiesAsync } from '../Common/api-clients/terminologiesClient';
import { AppState } from "../Common/Reducer/rootReducerTypes";
import { updateTerminologies } from '../Common/Reducer/terminologiesActionsAndReducer';
import { BackendTypeName } from "../Common/Utils/backendDataParser";
import useBackendData from "./useBackendData";

export default function useTerminology() {
  const dispatch = useDispatch();
  const user = useSelector((state: AppState) => state.user);
  const terminologies = useSelector((state: AppState) => state.terminologyState.terminologies);
  const [selectedClient] = useBackendData();

  useEffect(() => {
    if (user && !terminologies && selectedClient.backendName === BackendTypeName.Handyman) {
      getTerminologiesAsync(selectedClient.name)
        .then(terminologies => {
          dispatch(updateTerminologies(terminologies));
        });
    }
  }, []);

  return terminologies;
}